import { EMAIL_RFC2822_REGEX } from 'commons/constants';

const isValidEmail = (email: string): boolean => EMAIL_RFC2822_REGEX.test(email);

export default isValidEmail;
